import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const Dismissal: FC = () => {
return (
    
    <Box mt={1}>
        <Header>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={7}>Дата увольнения</Typography>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "170px", mb: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={12.7}>Основание</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mb: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={3.3}>Причина увольнения</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mb: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={7.8}>№ статьи ТК РФ</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "200px", mb: 1}}
                />
                <Typography mr={1} ml={1}>Пункт</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px", mb: 1}}
                />
                <Typography mr={1} ml={1}>часть</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px", mb: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={12.9}>№ приказа</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "300px", mb: 1}}
                />
                <Typography mr={1} ml={1}>&</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px", mb: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={10.6}>Дата приказа</Typography>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{width: "170px", mb: 1}}
                />
            </Box>
        </Header>
        <Body>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={10.2}>Месяц отчета</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px", mb: 1}}
                />
                <Typography mr={1} ml={1}>год отчета</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "100px", mb: 1}}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{width: "170px", mb: 1, ml: 1}}
                />
            </Box>
            <Box display='flex' alignItems={'center'}>
                <Typography mr={18.2}>UUID</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "600px", mb: 1}}
                />
            </Box>
        </Body>
    </Box>
);
};

export default Dismissal;
